
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/dynamodb",
      function () {
        return require("private-next-pages/destinations/dynamodb.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/dynamodb"])
      });
    }
  